<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xml:space="preserve"
    width="40.6731mm"
    height="32.1803mm"
    version="1.1"
    style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
    viewBox="0 0 1640.75 1298.15"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <style type="text/css">
        <![CDATA[
         .fil0 {fill:#373435}
        ]]>
      </style>
    </defs>
    <g id="Camada_x0020_1">
      <metadata id="CorelCorpID_0Corel-Layer" />
      <path
        class="fil0"
        d="M160 0l1320.74 0c88.01,0 160,71.99 160,160.04l0 0c0,88.01 -71.99,160 -160,160l-1320.74 0c-88.01,0 -160,-71.99 -160,-160l0 0c0,-88.04 71.99,-160.04 160,-160.04zm0 491.32l1155.7 0c88.01,0 160,71.99 160,160.04l0 0c0,88.01 -72.47,160 -160,160l-1155.7 0c-87.53,0 -160,-71.99 -160,-160l0 0c0,-88.04 71.99,-160.04 160,-160.04zm0 486.79l867.24 0c88.01,0 160,71.99 160,160.04l0 0c0,88.01 -72.54,160 -160,160l-867.24 0c-87.46,0 -160,-71.99 -160,-160l0 0c0,-88.05 71.99,-160.04 160,-160.04z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IcoMenu',
}
</script>
